import { capabilities } from '../../capabilities';
import { args } from '../../common/args';
import { getPortalId } from '../../common/utils';
import { defineComponent } from '../../platform/models/nav-component-definition';
import { NAV_OBJECT_CREATE_COMPONENT, Tags } from '../constants';
import { getStyle } from './internal/get-style';
export const navObjectCreateDef = defineComponent(NAV_OBJECT_CREATE_COMPONENT, {
  name: NAV_OBJECT_CREATE_COMPONENT,
  path: `/nav-object-create-ui/${getPortalId()}/`,
  initiallyOpen: false,
  capabilities: [capabilities.HIDE_COMPONENT_CAP.getName(), capabilities.ALERT_MESSAGE_CAP.getName()],
  propsSchema: {
    createObject: args.string()
  },
  initialProps: {
    createObject: ''
  },
  iframeProps: {
    id: 'nav-object-create-iframe',
    style: getStyle()
  },
  renderTo: () => window.document.getElementById('nav-object-create-root'),
  tags: [Tags.SIDE_PANEL]
});